import { useTranslation } from 'react-i18next';
import type {
  MaintenancePriority,
  MaintenanceStatus,
} from '@/services/maintenances-service/maintenances-service.types';

// The values are the API contract; the labels come from the dictionary at render time.
// A `t()` call in a module-level array would run once, at import, and never follow the language.
const STATUSES: MaintenanceStatus[] = ['open', 'closed', 'in_progress'];
const PRIORITIES: MaintenancePriority[] = ['critical', 'high', 'medium', 'low'];
const CREATED_BY = ['yardi', 'respondit'] as const;

export const useStatusOptions = () => {
  const { t } = useTranslation('maintenances');
  return STATUSES.map((value) => ({ value, label: t(`status.${value}`) }));
};

export const usePriorityOptions = () => {
  const { t } = useTranslation('maintenances');
  return PRIORITIES.map((value) => ({ value, label: t(`priority.${value}`) }));
};

export const useCreatedByOptions = () => {
  const { t } = useTranslation('maintenances');
  return CREATED_BY.map((value) => ({ value, label: t(`createdBy.${value}`) }));
};
